import { render, staticRenderFns } from "./Dating.vue?vue&type=template&id=2a3b21c4&scoped=true&"
import script from "./Dating.vue?vue&type=script&lang=js&"
export * from "./Dating.vue?vue&type=script&lang=js&"
import style0 from "./Dating.vue?vue&type=style&index=0&id=2a3b21c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3b21c4",
  null
  
)

export default component.exports